/**
 * @flow
 * @relayHash 820adcf9243821b98b77594fe5256d9c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateContractorNoteInput = {|
  content: string,
  id: string,
  clientMutationId?: ?string,
|};
export type UpdateContractorNoteMutationVariables = {|
  input: UpdateContractorNoteInput
|};
export type UpdateContractorNoteMutationResponse = {|
  +updateContractorNote: ?{|
    +updatedContractorNote: ?{|
      +id: string,
      +content: ?string,
      +contentEditedAt: ?any,
    |}
  |}
|};
export type UpdateContractorNoteMutation = {|
  variables: UpdateContractorNoteMutationVariables,
  response: UpdateContractorNoteMutationResponse,
|};
*/


/*
mutation UpdateContractorNoteMutation(
  $input: UpdateContractorNoteInput!
) {
  updateContractorNote(input: $input) {
    updatedContractorNote {
      id
      content
      contentEditedAt
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateContractorNoteInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateContractorNote",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateContractorNotePayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updatedContractorNote",
        "storageKey": null,
        "args": null,
        "concreteType": "ContractorNoteNode",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "content",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "contentEditedAt",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateContractorNoteMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateContractorNoteMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateContractorNoteMutation",
    "id": null,
    "text": "mutation UpdateContractorNoteMutation(\n  $input: UpdateContractorNoteInput!\n) {\n  updateContractorNote(input: $input) {\n    updatedContractorNote {\n      id\n      content\n      contentEditedAt\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e5533c640e0a1baeb22fdf097929bf79';
module.exports = node;
